window.variant_modal = {};
window.variant_modal.items_to_add = Array();
window.variant_modal.item_objs_to_add = Array();

function ready(fn){var d=document;(d.readyState=='loading')?d.addEventListener('DOMContentLoaded',fn):fn();}
ready(function () {
  cartLoadingHide();
  updateCartState();
  detectAddToCartButtonClicks();
  detectAddToCartFormSubmit();
});

function detectAddToCartButtonClicks() {
  $('body').on('click', 'button', function() {
    var button = $(this);
    if (button.hasClass('out-of-stock')) {
      var variant_id = button.data('variant-id');
      window.location = button.data().url + '?variant-id=' + variant_id + '#notify-me';
      return;
    }

    if (button.attr('data-action') == 'add') {
        var productHandle = $(this).data('product-handle');
        var productId = $(this).data('product-id');
        var variantId = $(this).data('variant-id');
        quickAddToCartWithLimitCheck(variantId, productHandle);
    } else if (button.attr('data-action') == 'remove') {
      var variantId = $(this).attr('data-variant-id');
      removeFromCart(variantId);
    } else if (button.attr('data-action') == 'update-quantity') {
      if (button.attr('data-method') == 'increment') {
        var variantHandle = $(this).attr('data-variant-handle');
        incrementItemQuantity(button.attr('data-variant-id'), variantHandle);
      } else if (button.attr('data-method') == 'decrement') {
        decrementItemQuantity(button.attr('data-variant-id'));
      }
    } else {

    }
  });
}

/*
function detectAddToCartFormSubmit() {
  $('form[data-productid]').on('submit', function (event) {
    event.preventDefault();
    var _this = $(this);
    var form_data = $(_this).serializeArray();
    prodAddToCart(form_data);
    return false;
  });
}
*/

function detectAddToCartFormSubmit() {
  $('form[data-productid]').on('submit', function (event) {
    event.preventDefault();
    var _this = $(this);
    var data;
    let isListViewItem = _this.data().list_view_item;

    if(isListViewItem) {
      data = {items: []};
      _this.find('.prod-main-quantity-input').each((index, item) => {
        let q = item.value;
        let variant_id = $(item).data().variant_id;
        if(q > 0 && variant_id) {
          data.items.push({
            id: variant_id,
            quantity: q
          });  
        }
      });

      let d = $(_this).serializeArray();

      for (let i = 0; i < d.length; i++) {
        const element = d[i];

        if(element.name == "id" || element.name == "quantity") {
          continue;
        }

        if( element.name.indexOf("[") > -1 && element.name.indexOf("]") > -1 ) {
          let parts = element.name.split("[");
          let n = parts[0];
          let v = parts[1].substr(0, parts[1].length - 1);
          
          for (let j = 0; j < data.items.length; j++) {
            let data_item = data.items[j];
            data_item[n] = {};
            data_item[n][v] = element.value;
          }

        } else if (element.name.indexOf("selling") > -1) {
          for (let j = 0; j < data.items.length; j++) {
            let data_item = data.items[j];
            data_item[element.name] = element.value;
          }
        
        } else {
          data[element.name] = element.value;
        }
      }
  
    } else {
      data = $(_this).serializeArray();
    }
    
    prodAddToCart(data);

    return false;
  });
}

function prodAddToCart(form_data, callback) {
  cartLoadingShow();
  console.log('TEST ADD TO CART --- 2');
  $.ajax({
    type: 'POST',
    url: '/cart/add.json',
    data: form_data,
    success: function(data) {
      //console.log('data');
      //console.log(data);
      
      addDrawstringBagIfNeeded(function () {
        updateCartState();
        if(typeof callback == 'function') {
          callback();
        }
      });
    },
    error: function(xhr, textStatus, error) {
        console.log(xhr.statusText);
        console.log(textStatus);
        console.log(error);
        addDrawstringBagIfNeeded(function () {
          updateCartState();
          if(typeof callback == 'function') {
            callback();
          }
        });
    }
  });
}

function addOnProductsItem(add_on_options, callback) {
  var add_on_options_data = {
    items: Array()
  };          

  for (var i = 0; i < add_on_options.length; i++) {
    const option = add_on_options[i];
    const add_on_variant_id = option.value;
    add_on_options_data.items.push({
      "quantity": 1,
      "id": add_on_variant_id
    });
  }
  console.log('TEST ADD TO CART --- 3');

  $.ajax({
    type: 'POST',
    url: '/cart/add',
    data: add_on_options_data,
    success: function(data) {
      addDrawstringBagIfNeeded(callback);
      //if(typeof(callback) == 'function')
      //callback();
    },
    error: function(xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
      addDrawstringBagIfNeeded(callback);
    }
  });
};

function addToCart(variantId, quantity, form, callback) {
  cartLoadingShow();
  var formdata = false;

  if(window.FormData){
    formdata = new FormData(form)
  }
  console.log('TEST ADD TO CART --- 4');

  $.ajax({
    type: 'POST',
    url: '/cart/add.json',
    data: formdata ? formdata : $addToCartForm.serialize(),
    contentType : false,
    processData : false,
    success: function(data) {
      var add_on_options = $('.add-on-products input[type="checkbox"]:checked');
      if (add_on_options.length) {
          addOnProductsItem(add_on_options, function(){
            updateCartState(data);

            addDrawstringBagIfNeeded(callback);  
            //if(typeof(callback) == 'function')
            //callback();
          });
      } else {
        addDrawstringBagIfNeeded(function () {
          updateCartState(data);
          if(typeof(callback) == 'function')
            callback();
        });
      }
    },
    error: function(xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
      addDrawstringBagIfNeeded(function () {
        if(typeof(callback) == 'function')
          callback();
      });
    }
  });

  if(isIphone()) {
    if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 100);
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 200);
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 300);
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 400);
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 500);
    setTimeout(function () {if($('.modal-backdrop').length) $('.modal-backdrop').css('display', 'none');}, 1000);
  }
}

function isIphone() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

var to_1 = null;
var to_2 = null;
function showLimitWarningPopup() {
  $($('.quantity-warning-popup')[0]).removeClass('show');
  $($('.quantity-warning-popup')[0]).addClass('show');
  $($('.quantity-warning-popup')[0]).fadeIn(400);
  var r = -$($('.quantity-warning-popup')[0]).width() + 50;
  var t = -$($('.quantity-warning-popup')[0]).height() - 10;
  $($('.quantity-warning-popup')[0]).css('right', r + 'px');
  $($('.quantity-warning-popup')[0]).css('top', t + 'px');

  clearTimeout(to_1);
  to_1 = setTimeout(function () {
      $($('.quantity-warning-popup')[0]).css('opacity', '0');
      clearTimeout(to_2);
      to_2 = setTimeout(function () {
          $($('.quantity-warning-popup')[0]).css('opacity', '1');
          $($('.quantity-warning-popup')[0]).removeClass('show');
          $($('.quantity-warning-popup')[0]).fadeOut(400);
      }, 2200);
  }, 5000);
}

function isProductLimited(variant_id, product_handle, hasLimitBeenReached_callback, quickAddToCart_callback) {
  $.getJSON('/products/' + product_handle + '?view=json_product', {}, function (data) { 
    //console.log('data.product'); 
    //console.log(data.product);
    data.product.tags = data.product.tags.split(', '); 
    if(data.product.tags.includes(max_order_product_tag) || data.product.tags.includes(max_order_product_tag_2)) {
      hasLimitBeenReached_callback(variant_id, quickAddToCart_callback, max_order);
    } else if(data.product.tags.includes(max_order_product_tag_3)) {
      hasLimitBeenReached_callback(variant_id, quickAddToCart_callback, max_order_2);    
    } else {
      quickAddToCart_callback(variant_id);
    }  
  }, function (xhr, textStatus, error) {
    console.log(xhr.statusText);
    console.log(textStatus);
    console.log(error);
  });
}

function hasLimitBeenReached(variant_id, quickAddToCart_callback, _max_order) {
  var has_limit_been_reached = false;
  $.getJSON('/cart.js', {}, function (cart) {
    var l_found_item_r = null;
    for(var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if(item.variant_id == variant_id) {
            l_found_item_r = item;
            break;
        }
    }

    var existing_quantity = 0;

    if(l_found_item_r) {
      existing_quantity = l_found_item_r.quantity;
    }

    has_limit_been_reached = (existing_quantity + 1 > _max_order);

    if(has_limit_been_reached) {
      showLimitWarningPopup();
    } else {
      quickAddToCart_callback(variant_id);
    }
  }, function () {
    console.log('error adding');
  });
}

function quickAddToCart(variant_id) {
  cartLoadingShow();
  var prepareData = {
    "quantity": 1,
    "id": variant_id
  };
  console.log('TEST ADD TO CART --- 5');

  $.ajax({
    type: 'POST',
    url: '/cart/add.json',
    data: prepareData,
    success: function(data) {
      addDrawstringBagIfNeeded(function () {
        updateCartState(data);
        var on_cart_page = $('meta[data-on-cart-page]').length;
        if(on_cart_page) {
          $(document).scrollTop(0);
        }  
      });
    },
    error: function(xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
    }
  });
}

function quickAddToCartWithLimitCheck(variant_id, product_handle) {
  isProductLimited(variant_id, product_handle, hasLimitBeenReached, quickAddToCart);
}

function incrementItemQuantity(variantId, variantHandle) {
  cartLoadingShow();
  var t_o_1 = null;
  var t_o_2 = null;
  var prepareData = {}
  var currentQuantity = $("[data-item-id='" + variantId + "']").find("[data-content='item-quantity']").val();
  var newQuantity = parseInt(currentQuantity) + 1
  var v_id = variantId.substr(0, variantId.indexOf(':'));
  var limitedVariantIds = Array('33254475235373', '33254475268141', '33254475300909');
  var limited = limitedVariantIds.includes(v_id);
  var url = "/products/" + variantHandle + "?view=json_product";
  
  jQuery.ajax({
    url: url,
    async: false,
    success: function(response) {              
      var product = JSON.parse(response);
      if(max_order_enabled 
        && ((product.tags.includes(max_order_product_tag ) && max_order < newQuantity)
          || (product.tags.includes(max_order_product_tag_2 ) && max_order < newQuantity)
          || (product.tags.includes(max_order_product_tag_3 ) && max_order_2 < newQuantity)
        )) {

          var popup = $("[data-item-id='" + variantId + "']").find("[data-content='quantity-warning-popup']");
          popup.removeClass('show');
          popup.addClass('show');
          popup.fadeIn(400);
          var r = -popup.width() + 50;
          var t = -popup.height() - 10;
          popup.css('right', r + 'px');
          popup.css('top', t + 'px');
          clearTimeout(t_o_1);
          t_o_1 = setTimeout(function () {
              popup.css('opacity', '0');
              clearTimeout(t_o_2);
              t_o_2 = setTimeout(function () {
                  popup.css('opacity', '1');
                  popup.removeClass('show');
                  popup.fadeOut(400);
              }, 2200);
          }, 5000);

          addDrawstringBagIfNeeded(function () {

            updateCartState();

            if(typeof(disableAddButtonIfNeeded) === typeof(Function)) 
              disableAddButtonIfNeeded();
          });
          return;
      }

      prepareData[variantId] = newQuantity
      var data = {
        updates: prepareData
      };

      posting = jQuery.post('/cart/update.json', data);
      posting.done(function(data) {
        item = data;
        addDrawstringBagIfNeeded(function () {
          updateCartState();
          if(typeof(disableAddButtonIfNeeded) === typeof(Function)) 
            disableAddButtonIfNeeded();
        });
      });
    }
  });
}

function decrementItemQuantity(variantId) {
  cartLoadingShow();
  var is_removed = false;
  var prepareData = {}
  var currentQuantity = $("[data-item-id='" + variantId + "']").find("[data-content='item-quantity']").val();
  var newQuantity = parseInt(currentQuantity) - 1
  is_removed = newQuantity == 0;
  prepareData[variantId] = newQuantity
  var data = {
    updates: prepareData
  };

  posting = jQuery.post('/cart/update.json', data);
  posting.done(function(cart) {
    item = cart;
    //console.log('cart');
    //console.log(cart);
    if(is_removed) {
      if(onlyFreeItemsInCart(cart)) {
        emptyCart(function () {
          updateCartState();
          if(typeof(disableAddButtonIfNeeded) === typeof(Function)) 
            disableAddButtonIfNeeded();
        });
        return;
      }
      else {
        //window.location.reload();
        updateCartState();
        if(typeof(disableAddButtonIfNeeded) === typeof(Function)) {
           disableAddButtonIfNeeded();    
        }
      }
    }
    addDrawstringBagIfNeeded(function () {
      updateCartState();
      if(typeof(disableAddButtonIfNeeded) === typeof(Function))
        disableAddButtonIfNeeded();
    });  

  });
}

function onlyFreeItemsInCart(cart) {
  if(undefined !== cart && cart.items) {
    for(i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if(item.final_price > 0) {
        return false;
      }
    }
  }
  return true;
};

function emptyCart(callback) {
  $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function (cart) {
          if(callback) callback();
      }
  });
}

function changeItemQuantity(variantId, quantity) {
  cartLoadingShow();
  var prepareData = {}
  prepareData[variantId] = quantity
  var data = {
    updates: prepareData
  };

  posting = jQuery.post('/cart/update.json', data);

  posting.done(function(data) {
    item = data;
    updateCartState();
  });
}

function removeFromCart(variantId) {
  cartLoadingShow();
  var prepareData = {}
  prepareData[variantId] = 0
  var data = {
    updates: prepareData
  };

  posting = jQuery.post('/cart/update.json', data);
  posting.done(function(data) {
    addDrawstringBagIfNeeded(function () {
      updateCartState();
    });
  });
}

function freeGiftShouldBeRemoved(data) {
  if(!window.free_gift_product_handle || !window.free_gift_variant_id || !window.free_gift_trashold) {
    return false;
  }
  for(let i = 0; i < data.items.length; ++i) {
    let item = data.items[i];
    if(item.handle == window.free_gift_product_handle) {
      if(item.variant_id == window.free_gift_variant_id) {
        if(data.total_price < window.free_gift_trashold) {
          return true;
        }
      }
    }
  }  
  return false;
}

function freeGiftShouldBeAdded(data) {
    return false;
  /*
  if(!window.free_gift_product_handle || !window.free_gift_variant_id || !window.free_gift_trashold) {
    return false;
  }
  for(let i = 0; i < data.items.length; ++i) {
    let item = data.items[i];
    if(item.handle == window.free_gift_product_handle) {
      if(item.variant_id == window.free_gift_variant_id) {
        if(data.total_price < window.free_gift_trashold) {
          return false;
        }
      }
    }
  }  
  return true;
  */
}

function updateCartState() {
  var getting = jQuery.getJSON('/cart.js', {});
  getting.done(function(data) {

    if(freeGiftShouldBeRemoved(data)) {
      var updates = {};
      updates[window.free_gift_variant_id] = 0;
      var send_data = {
        updates: updates
      };
      posting = jQuery.post('/cart/update.json', send_data);
      posting.done(function(cart) {
        updateCartState();
      });
      return;
   } else if(freeGiftShouldBeAdded(data)) {
      var updates = {};
      updates[window.free_gift_variant_id] = 1;
      var send_data = {
        updates: updates
      };
      posting = jQuery.post('/cart/update.json', send_data);
      posting.done(function(cart) {
        updateCartState();
      });
      return;
   }
    
    $('#cart_line_items_modal').html('');
    $('#cart_line_items_page').html('');

    var items = data['items'];

    let recommended_product_in_cart = false;
    $.each(items, function(key, item){ 
      renderCartLineItem(item, "cart_line_item_modal", "cart_line_items_modal");
      if($('#cart_line_items_page').length) {
        renderCartLineItem(item, "cart_line_item_page", "cart_line_items_page");
      }
      if (window.cart_modal_recommended_product_id != '' && !recommended_product_in_cart) {
        if (item.product_id == window.cart_modal_recommended_product_id) {
          $('.recommended-product-wrapper').removeClass('hidden');
          $('.recommended-product-wrapper').addClass('hidden');
          recommended_product_in_cart = true;
        } else {
          $('.recommended-product-wrapper').removeClass('hidden');
        }
      }
    });

    cartLoadingHide();

    formattedPrice = '£' + (data.total_price / 100.0).toFixed(2);
    $("[data-content='cart-subtotal']").html(formattedPrice);

    var thresholdPrice = $("[data-content='free-threshold-progress-bar']").data().limit;
    var freeDeliveryThreshold = thresholdPrice - data.total_price;
    if(freeDeliveryThreshold <= 0) {
      var freeDelivery = window.cart_modal_free_threshold_free_text;
    }
    else {
      var cart_modal_free_threshold_not_free_text = window.cart_modal_free_threshold_not_free_text.replace("((price))", (freeDeliveryThreshold / 100.0).toFixed(2));
      var freeDelivery = cart_modal_free_threshold_not_free_text;
    }
    $("[data-content='free-threshold-price']").html(freeDelivery);
    $("[data-content='free-threshold-progress-bar']").val(data.total_price);
    
    updateMenuBagIndicator(data.item_count);

    if(typeof(disableAddButtonIfNeeded) == 'function') {
      disableAddButtonIfNeeded();
    }
  });
}

function cartLoadingHide() {
  $('.cart-loading').fadeOut();
}

function cartLoadingShow() {
  $('.cart-loading').fadeIn();
}

function updateMenuBagIndicator(total_num) {
  $('.bag-item-count').html(total_num)
}

function renderCartLineItem(item, item_id, to_id) { 
  //console.log("cart item")
  //console.log(item)
  let clone_item_id = item_id;
  var clone = $('#' + clone_item_id + '').clone();
  clone.hide();
  clone.show();

  if(item.final_price == 0) {
    clone.find('.cart-quantity-selector').addClass('hide');
  }
  clone.attr('id', item.key);
  clone.attr('data-item-id', item.key);
  clone.appendTo("#" + to_id);
  
  // Remove the clone's template ID
  clone.removeAttr('id');
  
  // Don't show cart images on IE 
  if (detectIE() != false) {
    clone.find('.modal-product-image').attr('style', 'display:none;');
  }
  clone.find('.modal-product-image').attr("src", item.image);
  clone.find('[data-content="item-title"]').html(item.title);

  if (item.properties === null) {
    clone.find('[data-content="item-properties"]').html('');
  } else {
    if (item.properties['products'] != null) {
      formattedProperties = item.properties['products'].replace('- ', '');
      clone.find('[data-content="item-properties"]').html(formattedProperties);
    }

    if (item.properties['message'] != null) {
      formattedProperties = item.properties['message'].substr(0, 1000);
      clone.find('[data-content="item-properties"]').html(formattedProperties);
    }

    if (item.properties['summary'] != null) {
      formattedProperties = item.properties['summary'].substr(0, 1000);
      clone.find('[data-content="item-properties"]').html(formattedProperties);
    }
  }

  if(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan){
    clone.find('[data-content="bold-subscription-properties"]').text(item.selling_plan_allocation.selling_plan.name);
  }

  if(item.final_price == 0) {
    clone.find('[data-content="item-price"]').html('Free');
  } else {
    clone.find('[data-content="item-price"]').html('£' + (item.price / 100.0).toFixed(2) + ' each');
  }

  clone.find('[data-content="item-quantity"]').html(item.quantity);
  clone.find('[data-content="item-quantity"]').val(item.quantity);
  clone.find('[data-content="item-quantity"]').attr('value', item.quantity);
  clone.find('[data-content="quantity-warning-popup"]').attr('id', item.variant_id);
  clone.find('[data-content="quantity-warning-popup"]').addClass('quantity-warning-popup');
  clone.find('[data-content="item-subtotal"]').html('£' + (item.line_price / 100.0).toFixed(2));
  clone.find('[data-action="update-quantity"]').attr('data-variant-id', item.key);
  clone.find('[data-action="update-quantity"]').attr('data-variant-handle', item.handle);
  clone.find('[data-action="remove"]').attr('data-variant-id', item.key);
  clone.find('[data-content="item-url"]').attr('href', item.url);

  $(clone.find('[data-content="item-quantity"]')).on("keyup", function() {
    var quantity = $(this).val();
    if (quantity != "") {
      changeItemQuantity(item.variant_id, quantity);
    }
  });
}

function detectIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  // other browser
  return false;
}